document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('video-section');
  const playBtn = document.getElementById('video-play-btn');
  const modal = document.getElementById('video-modal');
  const modalVideo = document.getElementById('modal-video');
  const modalClose = document.getElementById('video-modal-close');

  if (playBtn && section) {
    // Hover effect for background glow
    playBtn.addEventListener('mouseenter', function () {
      section.classList.add('is-button-hovered');
    });

    playBtn.addEventListener('mouseleave', function () {
      section.classList.remove('is-button-hovered');
    });

    // Modal logic
    if (modal && modalVideo && modalClose) {
      let lastFocusedElement = null;

      playBtn.addEventListener('click', function () {
        lastFocusedElement = document.activeElement;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        modalVideo.play();
        document.body.style.overflow = 'hidden'; // Disable scroll
        setTimeout(() => {
          modalClose.focus();
        }, 100);
      });

      const closeModal = function () {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        modalVideo.pause();
        modalVideo.currentTime = 0;
        document.body.style.overflow = ''; // Enable scroll
        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      };

      modalClose.addEventListener('click', closeModal);

      modal.addEventListener('click', function (e) {
        if (e.target === modal) {
          closeModal();
        }
      });

      // Escape key to close
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
  }

  // ─── Hero Globe Scroll Scale ─────────────────────────────────────────────
  const heroGlobe = document.querySelector('.hero__globe');
  if (heroGlobe) {
    const heroGlobeSvg = heroGlobe.querySelector('svg');

    if (heroGlobeSvg) {
      heroGlobeSvg.addEventListener('animationend', (e) => {
        if (e.animationName === 'globeScaleDown') {
          heroGlobe.classList.remove('is-scale-down');
        }
      });
    }

    const handleGlobeScroll = () => {
      if (window.scrollY > 50) {
        heroGlobe.classList.remove('is-scale-down');
        heroGlobe.classList.add('is-scaled');
      } else {
        if (heroGlobe.classList.contains('is-scaled')) {
          heroGlobe.classList.remove('is-scaled');
          heroGlobe.classList.add('is-scale-down');
        }
      }
    };
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
      window.addEventListener('scroll', handleGlobeScroll, { passive: true });
      // Check initial position in case page is refreshed while scrolled
      handleGlobeScroll();
    }
  }
});
